import { apiRequest } from "../client";
import type {
  Document,
  CloudDocumentCreate,
  CloudDocumentUpdate,
} from "./types";

/**
 * Create a new cloud document
 */
export const createCloudDocument = async (
  data: CloudDocumentCreate
): Promise<Document> => {
  const response = await apiRequest<Document>({
    method: "POST",
    url: "/documents/cloud",
    data,
  });
  return response;
};

/**
 * Update an existing cloud document
 */
export const updateCloudDocument = async (
  documentId: string,
  data: CloudDocumentUpdate
): Promise<Document> => {
  const response = await apiRequest<Document>({
    method: "PUT",
    url: `/documents/cloud/${documentId}`,
    data,
  });
  return response;
};

/**
 * Delete a cloud document
 */
export const deleteCloudDocument = async (
  documentId: string
): Promise<void> => {
  await apiRequest({
    method: "DELETE",
    url: `/documents/${documentId}`,
  });
};

export type { CloudDocumentCreate, CloudDocumentUpdate, Document };
